import {Component, ViewChild, OnInit, Directive} from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import {UserService} from '../../core/services/user.service';
import {GlguideService} from '../../core/services/glguide.service';
import {GLGuide} from '../../core/shared/model/GLGuide';
import {Subscription} from 'rxjs';
import {TabStripComponent, TabStripTabComponent} from '@progress/kendo-angular-layout';
import {LoggingService} from "mclane-apptemplate-lib";

@Component({
  selector: 'app-glguidemenu',
  templateUrl: './glguidemenu.component.html',
  styleUrls: ['./glguidemenu.component.scss']
})

export class GLGuideMenuComponent implements OnInit {

  @ViewChild('tabs') tabGroup: MatTabGroup;

  public onTabSelect(e) {
  }
  username: string;
  glguides: Array<GLGuide>;
  selectedGlGuides: Array<GLGuide>;
  selectedGluideIds: number[];

  s: Subscription;
  wasLoaded: boolean;

  constructor(public userService: UserService, public glguideService: GlguideService, public console: LoggingService) {

  }

  ngOnInit(): void {

  }

}


